<template>
  <div class="floor">
    <div class="name" v-text="title"></div>
    <div class="sale-state">
      <span>
        已网签备案:{{ summary.sellNum }}
      </span>&nbsp;&nbsp;
      <span>
        待网签备案:{{ summary.nosaledNum }}
      </span>&nbsp;&nbsp;
      <span>
        自留/非卖:{{ summary.nosaleNum }}
      </span>&nbsp;&nbsp;
      <span>
        总计:{{ summary.totalNum }}
      </span>&nbsp;&nbsp;
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Floor',
    props: {
      title: String,
      summary: Object
    }
  }
</script>

<style lang="scss">
  .floor {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    background-color: #F8F8FF;
    .name {
      color: #3485FB;
      padding-left: 2px;
    }
    .sale-state {
      color: #7d7e80
    }
  }
</style>
